import React, { useContext, useEffect, useState } from "react";
// import TableDetails from "../DataTable/TableDetails";
import SearchInput from "../search/SearchInput";
import ActionButton from "../../components/Button/ActionButton";
import "./PublisherContent.scss";
import TableDetails from "../table/TableDetails";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import { downloadExcel } from "../Button/GraphDownloadButton/GraphDownloadButton";
import { AppContext } from "../../context/AppContext";

const PublisherContent = ({
  tableData,
  totalRecords,
  queryData,
  setQueryData,
  handleSort,
  handleRowClick,
  loading,
  onSearch,
  onChange,
}) => {
  const { get } = useCustomSearchParams();
  const [shortName, setShortName] = useState(get(SEARCH_PARAMS.SHORT_NAME));
  const { selectedFilterBy, selectedFilterByLabel } = useContext(AppContext);

  return (
    <div className="publisher-table">
      <div className="table-toolbar">
        <div className="search-wrapper">
          {/* <SearchInput
            placeholder="Search for a record"
            onSearch={onSearch}
            onChange={onChange}
            selectedSearchValue={get(SEARCH_PARAMS.ENTITY_CONTENT_SEARCH)}
          /> */}
        </div>

        <div className="action-button">
          <ActionButton
            icon={faDownload}
            onClick={() =>
              downloadExcel(
                tableData?.data,
                `${shortName}${selectedFilterBy !== "ALL" ? "__" + selectedFilterByLabel?.trim() : ""} Records Tracked by CHORUS`,
              )
            }
            // icon={<Download size={13} />}
            label="Download Records"
          />
        </div>
      </div>
      {/* <hr /> */}
      <TableDetails
        tableData={tableData?.data}
        headers={tableData.config} //{TABLE_CONFIG}
        totalRecords={totalRecords}
        paginationData={{ page: queryData.page, size: queryData.size }}
        setPaginationData={setQueryData}
        headerClassification={true}
        showPagination={true}
        start={0}
        handleSort={handleSort}
        sort={{
          field: queryData.sortKey,
          order: queryData.sortOrder,
        }}
        onRowClick={handleRowClick}
        loading={loading}
        stickyTableHeader={true}
      />
    </div>
  );
};

export default PublisherContent;
